// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"Lba-z","disabled":"Mba-z","label":"Nba-z"};